import React from "react"
import ReactDOM from "react-dom"
import ImpressionSliderComponent from "./impression-slider-component"

export default class ImpressionSliderModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ImpressionSliderComponent {...this.modelJson} />, self.elem)
  }
}
